import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import skiImage from '../../assets/services/ski.jpg';
import { FaMountain, FaSnowflake, FaUsers, FaCarAlt } from 'react-icons/fa';

function StationsSki() {
  const features = [
    {
      icon: <FaMountain />,
      title: "Toutes Stations",
      description: "Transport vers toutes les stations de ski de la région"
    },
    {
      icon: <FaSnowflake />,
      title: "Équipement Adapté",
      description: "Véhicules équipés pour le transport de matériel de ski"
    },
    {
      icon: <FaUsers />,
      title: "Groupes Bienvenus",
      description: "Service disponible pour particuliers et groupes"
    },
    {
      icon: <FaCarAlt />,
      title: "Confort Assuré",
      description: "Véhicules spacieux et confortables pour la montagne"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${skiImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Stations de Ski</h1>
          <p>Transport confortable vers vos destinations de ski préférées</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Transport Vers Les Stations de Ski</h2>
            <p>
              Profitez d'un transport confortable et sécurisé vers toutes les stations 
              de ski de la région. Nos véhicules sont spécialement équipés pour transporter 
              votre matériel de ski et de snowboard.
            </p>
            <p>
              Que vous soyez seul, en famille ou en groupe, nous nous adaptons à vos besoins 
              pour vous offrir un service de qualité et vous permettre de profiter pleinement 
              de votre journée à la montagne.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Réservez Votre Transport</h2>
            <p>
              Planifiez votre trajet vers les pistes dès maintenant pour une expérience sans souci.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default StationsSki; 